import request from "@/utils/request"


// 设备反馈历史列表
export function FeedbackList(page, pageSize, nameORnumber) {
  return request({
    url: "/feedback/findFeedbackPage",
    method: "POST",
    data: {
      page,
      pageSize,
      nameORnumber
    }
  })
};
// 指令记录列表
export function FeedbackCmdList(page, pageSize, nameORnumber) {
  return request({
    url: "/feedbackCmd/findFeedbackCmdPage",
    method: "POST",
    data: {
      page,
      pageSize,
      nameORnumber
    }
  })
};

// 设备列表
export function DeviceList(page, pageSize, nameORnumber, userId) {
  return request({
    url: "/device/findDeviceVptinfoPage",
    method: "POST",
    data: {
      page,
      pageSize,
      nameORnumber,
      userId
    }
  })
};
// 设备列表
export function DeviceListBYUserId(page, pageSize, nameORnumber, userId) {
  return request({
    url: "/device/findDeviceVptinfoBYUserIdPage",
    method: "POST",
    data: {
      page,
      pageSize,
      nameORnumber,
      userId
    }
  })
};
// 创建设备
export function addDevice(objectid,vptNum,name,pos,state,cmd,nameB,localNameB,deviceIdB,imeiB,remarkB,ccidB,deviceNum,vptCode,deviceType) {
  return request({
    url: "/device/addDeviceVptinfo",
    method: "POST",
    data: {
      objectid,vptNum,name,pos,state,cmd,nameB,localNameB,deviceIdB,imeiB,remarkB,ccidB,deviceNum,vptCode,deviceType
    }
  })
};
// 删除设备
export function DelDevice(objectid) {
  return request({
    url: `/device/deleteDeviceVptinfoById/${objectid}`,
    method: "DELETE",
    data: {
      objectid
    }
  })
};
//查看设备信息
export function DeviceInfo(objectid) {
  return request({
    url: `/device/getDeviceVptinfoById/${objectid}`,
    method: "GET",
    data: {
      objectid
    }
  })
};
// 修改设备信息
export function upDataDeviceInfo(objectid, deviceNum,vptNum,name,pos,state,cmd,cmdDate,isListener,nameB,localNameB,deviceIdB,imeiB,remarkB,ccidB, vptCode, deviceType) {
  return request({
    url: `/device/updateDeviceVptinfo`,
    method: "PUT",
    data: {
      objectid, deviceNum,vptNum,name,pos,state,cmd,cmdDate,isListener,nameB,localNameB,deviceIdB,imeiB,remarkB,ccidB, vptCode, deviceType
    }
  })
}

// 执行指令信息
export function execDeviceCmd(objectid,vptNum,name,pos,state,cmd,cmdDate) {
  return request({
    url: `/device/executeDeviceCmd`,
    method: "PUT",
    data: {
      objectid,vptNum,name,pos,state,cmd,cmdDate
    }
  })
}

// 检修状态-分页查询（支持批量 IMEI / 设备编号 / 出厂编码）
export function findMaintenancePage(data) {
  return request({
    url: "/vptinfo/findMaintenancePage",
    method: "POST",
    data
  })
}

// 检修状态-单个更新
export function updateMaintainStatus(data) {
  return request({
    url: "/vptinfo/updateMaintainStatus",
    method: "PUT",
    data
  })
}

// 检修状态-批量更新
export function batchUpdateMaintainStatus(data) {
  return request({
    url: "/vptinfo/batchUpdateMaintainStatus",
    method: "PUT",
    data
  })
}

// 检修状态变更记录
export function findStatusRecordPage(data) {
  return request({
    url: "/vptinfo/findStatusRecordPage",
    method: "POST",
    data
  })
}

